import React from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import type { ReviewStatsPeriodicInterface } from 'interfaces/review-stats.interface';
import type { CompanyInterface } from 'interfaces/company.interface';
import Rating from 'atomic/rating/rating';
import Icon from 'atomic/icon/icon';
import { currency } from 'helpers/number';
import CompanyViewCardSummaryShare
    from 'components/company-view/company-view-card/summary/share/company-view-card-summary-share';
import Link from 'atomic/link/link';
import { addUtmtoURL } from 'helpers/utm';

import './summary.scss';

const CompanyViewCardSummary: React.FC = () => {
    const { company, reviewStatsPeriodic } = useSelector(
        (state: { company: CompanyInterface; reviewStatsPeriodic: ReviewStatsPeriodicInterface[]; }) => (
            { company: state.company, reviewStatsPeriodic: state.reviewStatsPeriodic }
        )
    );

    const lastYearStats = reviewStatsPeriodic.find(item => item.period === 'oneYear');
    const everStats = reviewStatsPeriodic.find(item => item.period === 'ever');

    const logoBox = company.logoUrl
        ? <img src={company.logoUrl} alt={company.name}/>
        : (
            <div className="company-view-card__summary-no-logo">
                {company.name}
            </div>
        );

    return (
        <div className="company-view-card__summary">
            {
                company.url
                    ? (
                        <Link href={addUtmtoURL(company.url)} target="_blank" rel="nofollow noopener" className="company-view-card__summary-logo">
                            {logoBox}
                        </Link>
                    )
                    : (
                        <div className="company-view-card__summary-logo">
                            {logoBox}
                        </div>
                    )
            }
            {lastYearStats && (
                <>
                    <Rating className="company-view-card__summary-rating" value={lastYearStats.averageRating} width={125} readOnly={true}/>
                    <div className="company-view-card__summary-percentage">
                        <Icon icon="thumb-up-circle"/>
                        {' '}
                        <b>
                            {Math.round(100 * lastYearStats.positiveCount / lastYearStats.totalCount)}
                            <span>
                                %
                            </span>
                        </b>
                        {''}
                        <br/>
                        {''}
                        Klientów poleca
                        {' '}
                        {company.type === 'shop' ? 'ten sklep' : 'tę firmę'}
                    </div>
                    <div className="company-view-card__summary-rating-desc">
                        Na podstawie
                        {' '}
                        <b>
                            {currency(lastYearStats.totalCount)}
                        </b>
                        {' '}
                        opinii z ostatnich 12 m-cy
                    </div>
                    <hr className="company-view-card__summary-line"/>
                </>
            )}
            {everStats && (
                <div className="company-view-card__summary-total">
                    <Icon icon="comment"/>
                    {' '}
                    <b>
                        {currency(everStats.totalCount)}
                    </b>
                    {' '}
                    wszystkich opinii
                </div>
            )}
            <CompanyViewCardSummaryShare/>
        </div>
    );
};

export default CompanyViewCardSummary;
